export const buildStudentIdCardUploadPayload = ({
  studentIdCard,
  studentIdCardName,
  studentIdCardType,
}) => {
  const base64Data = studentIdCard.split(",")[1];
  const byteCharacters = atob(base64Data);

  return {
    fileType: "id-card",
    fileData: base64Data,
    fileName: studentIdCardName || "student-id.jpg",
    contentType: studentIdCardType || "image/jpeg",
    fileSize: byteCharacters.length,
    base64Length: base64Data.length,
  };
};

const readFileAsBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const base64Data = reader.result.split(",")[1];
      resolve(base64Data);
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });

export const buildPaperFileUploadPayload = async (paperFile) => {
  const base64Data = await readFileAsBase64(paperFile);

  return {
    fileType: "paper",
    fileData: base64Data,
    fileName: paperFile.name,
    contentType: paperFile.type,
    fileSize: paperFile.size,
    base64Length: base64Data.length,
  };
};
